module.exports = __webpack_public_path__ + "fec09f1a.png";